import React from 'react'
import { StyleSheet } from 'react-native';

const styler = ({ horizontal }) => {
    const style = { overflow: 'scroll', maxWidth: '100%' };

    if (horizontal) {
        style.overflowX = 'scroll';
        style.overflowY = 'hidden';
    } else {
        style.overflowY = 'scroll';
        style.overflowX = 'hidden';
    }

    return style
}

export default class ScrollView extends React.Component {
    state = {
        scrollWidth: 0,
        scrollHeight: 0,
    }

    easing = null
    div = React.createRef();

    componentDidMount(){
        setTimeout(this.checkSize, 1);
    }
    
    componentDidUpdate(){
        setTimeout(this.checkSize, 1);
    }

    checkSize = () => {
        if (!this.div.current) {
            return;
        }
        const newWidth = this.div.current.scrollWidth 
        const newHeight = this.div.current.scrollHeight;
        if (newWidth !== this.state.scrollWidth || newHeight !== this.state.scrollHeight) {
            this.setState({
                scrollWidth: newWidth,
                scrollHeight: newHeight,
            })

            this.props.onContentSizeChange && this.props.onContentSizeChange(newWidth, newHeight);
        }
    }

    ease = (horizontal, begin, target, t) => {
        const $this = this;
        const duration = 300
        const step = 50

        if (t >= duration) {
            // console.log('timeout')
            if (horizontal){ 
                this.div.current.scrollLeft = this.state.scrollWidth;
            } else {
                this.div.current.scrollTop = this.state.scrollHeight;
            }
        } else {
            const T = t / duration;

            const p = T*(2-T)
            // console.log('easing', t, T, p, duration, begin, target-begin)
            if (horizontal){ 
                this.div.current.scrollLeft = begin + p * (target - begin);
            } else {
                this.div.current.scrollTop = begin + p * (target - begin);
            }

            if (this.easing) {
                clearTimeout(this.easing)
            }

            this.easing = setTimeout(function(){
                $this.ease(horizontal, begin, target, t + step);
            } , step);
        }
    }

    scrollToEnd = () => {
        if (this.easing) {
            clearTimeout(this.easing)
            this.easing = null
        }
        if (this.props.horizontal) {
            this.ease(this.props.horizontal, this.div.current.scrollLeft, this.state.scrollWidth - this.div.current.offsetWidth, 0) 
            // this.div.current.scrollLeft = this.state.scrollWidth
        } else {
            this.ease(this.props.horizontal, this.div.current.scrollLeft, this.state.scrollHeight - this.div.current.offsetHeight, 0) 
            // this.div.current.scrollTop = this.state.scrollHeight
        }
    }
    
    render() {
        const {style, horizontal, ref, children} = this.props;

        
        
        return <div style={StyleSheet.flatten([style, styler({ horizontal })])} ref={this.div}>
            {children}
        </div>
    }
}
 
